module.exports = __webpack_public_path__ + "media/photo/philosophy-6666c789.jpg";